export default {
  getUnits(unitType) {
    const units = {
      "U.S.": {
        size: "gallons",
        distance: "ft",
        weight: "oz",
        lbs: "lbs",
        volume: "fl oz",
        temp: "Fahrenheit",
      },
      Metric: {
        size: "liters",
        distance: "m",
        weight: "g",
        lbs: "kgs",
        volume: "ml",
        temp: "Celsius",
      },
      Imperial: {
        size: "gallons",
        distance: "ft",
        weight: "oz",
        lbs: "lbs",
        volume: "fl oz",
        temp: "Fahrenheit",
      },
    };
    return units[unitType];
  },
  getMetric(oz) {
    if (oz > 10000) oz = Math.floor((oz + 500) / 1000) * 1000;
    else if (oz > 1000) oz = Math.floor((oz + 50) / 100) * 100;
    else if (oz > 100) oz = Math.floor((oz + 5) / 10) * 10;
    return oz / 1000;
  },
  getGallons(volume, unitType) {
    const gallons = {
      "U.S.": volume,
      Metric: volume / 3.78541,
      Imperial: volume * 1.20095,
    };
    return gallons[unitType];
  },
  getLbs(oz, unitType) {
    const lbs = {
      "U.S.": Math.floor(oz / 16 + 0.5),
      Metric: Math.floor(oz * 0.0283495 + 0.5),
      Imperial: Math.floor(oz / 16 + 0.5),
    };
    return lbs[unitType];
  },
  getVolume(oz, unitType) {
    const volume = {
      "U.S.":
        oz < 10
          ? Math.floor(oz + 0.05) + (Math.floor(oz * 10 + 0.5) % 10) / 10
          : Math.floor(oz + 0.5),
      Metric: Math.floor(oz * 29.5735 + 0.5),
      Imperial:
        oz * 1.04084 < 10
          ? Math.floor(oz * 1.04084 + 0.05) +
            (Math.floor(oz * 1.04084 * 10 + 0.5) % 10) / 10
          : Math.floor(oz * 1.04084 + 0.5),
    };
    return volume[unitType];
  },
  getWeight(oz, unitType) {
    const weight = {
      "U.S.":
        oz < 10
          ? Math.floor(oz + 0.05) + (Math.floor(oz * 10 + 0.5) % 10) / 10
          : Math.floor(oz + 0.5),
      Metric: Math.floor(oz * 28.3495 + 0.5),
      Imperial:
        oz < 10
          ? Math.floor(oz + 0.05) + (Math.floor(oz * 10 + 0.5) % 10) / 10
          : Math.floor(oz + 0.5),
    };
    return weight[unitType];
  },
  printWeight(oz, unitType) {
    var status = "";
    if (unitType === "Metric" && oz > 0) return this.getMetric(oz) + " kg";
    if (oz >= 16) {
      if (oz > 10 * 16) oz = Math.floor((oz + 8) / 16) * 16;
      status = Math.floor(oz / 16) + " lbs ";
    }
    return status + (oz - Math.floor(oz / 16) * 16) + " oz";
  },
  printVolume(oz, unitType) {
    var data = { div: unitType === "Imperial" ? 160 : 128, oz: oz, status: "" };
    var tsp = unitType === "Imperial" ? 0.5 / 4.8 : 0.5 / 6;

    if (unitType === "Metric" && oz > 0) return this.getMetric(oz) + " liters";
    if (oz < 0) return oz + " oz";
    if (oz === 0) return "None";

    data = this.printVolumeMagnitude(data);
    data = this.printVolumeGallons(data);
    data = this.printVolumeQuarts(data);
    data = this.printVolumeCups(data);
    data = this.printVolumeOz(data, tsp);
    data = this.printVolumeTsp(data, tsp);

    return data.status;
  },
  printVolumeMagnitude(data) {
    if (data.oz > 10 * data.div)
      data.oz = Math.floor((data.oz + data.div / 2) / data.div) * data.div;
    else if (data.oz > (10 * data.div) / 4)
      data.oz =
        Math.floor((data.oz + data.div / 8) / (data.div / 4)) * (data.div / 4);
    else if (data.oz > (10 * data.div) / 16)
      data.oz =
        Math.floor((data.oz + data.div / 32) / (data.div / 16)) *
        (data.div / 16);
    return data;
  },
  printVolumeGallons(data) {
    if (data.oz >= data.div) {
      data.status = Math.floor(data.oz / data.div) + " gallons ";
      data.oz -= Math.floor(data.oz / data.div) * data.div;
    }
    return data;
  },
  printVolumeQuarts(data) {
    data.div /= 4;
    if (data.oz >= data.div) {
      data.status =
        " " + data.status + Math.floor(data.oz / data.div) + " quarts ";
      data.oz -= Math.floor(data.oz / data.div) * data.div;
    }
    return data;
  },
  printVolumeCups(data) {
    data.div /= 4;
    if (data.oz >= data.div) {
      data.status =
        " " + data.status + Math.floor(data.oz / data.div) + " cups ";
      data.oz -= Math.floor(data.oz / data.div) * data.div;
    }
    return data;
  },
  printVolumeOz(data, tsp) {
    if (data.oz >= 1 - tsp) {
      data.status = " " + data.status + Math.floor(data.oz + tsp) + " fl oz ";
      data.oz -= Math.floor(data.oz + tsp);
    }
    return data;
  },
  printVolumeTsp(data, tsp) {
    if (data.oz >= tsp)
      data.status =
        " " + data.status + Math.floor((data.oz + tsp) / (tsp * 2)) + " tsp";
    return data;
  },
  printBags(weight, unitType) {
    var status = "";
    if (weight < 0) {
      return weight + (unitType === "Metric") ? " kgs" : " lbs";
    }
    if (unitType === "Metric" && weight > 0) {
      return this.printBagsKilos(status, weight);
    }
    return this.printBagsPounds(status, weight);
  },
  printBagsKilos(status, weight) {
    if (weight > 10 * 25) weight = Math.floor((weight + 25 / 2) / 25) * 25;
    if (weight >= 25) {
      status = Math.floor(weight / 25) + " (25 kg) bags";
      weight -= Math.floor(weight / 25) * 25;
      if (weight > 0) status = status + " and ";
    }
    return weight > 0 ? status + weight + " kgs" : status;
  },
  printBagsPounds(status, weight) {
    if (weight >= 40) {
      if (weight > 10 * 40) weight = Math.floor((weight + 40 / 2) / 40) * 40;
      status = Math.floor(weight / 40) + " (40 lb) bags";
      weight -= Math.floor(weight / 40) * 40;
      if (weight > 0) status = status + " and ";
    }
    return weight > 0 ? status + weight + " lbs" : status;
  },
  printBorax(oz, unitType) {
    var status = this.printWeight(oz, unitType);
    if (unitType === "Metric") {
      oz /= 28.3495;
    }
    if (oz >= 76) {
      return `
      ${status} or ${Math.floor((oz / 76) * 10 + 0.5) / 10} 
      (76 oz) boxes
    `;
    }
    return status;
  },
  printBleach(oz, jug, unitType) {
    var status = this.printVolume(oz, unitType);
    if (unitType === "Metric" && oz >= jug) {
      if (oz > jug * 10) {
        return `
        ${status} or ${Math.floor((oz + jug / 2) / jug)} 
        (${jug / 1000} liter) jugs
      `;
      } else {
        return `
        ${status} or ${Math.floor((oz / jug) * 10 + 0.5) / 10} 
        (${jug / 1000} liter) jugs
      `;
      }
    }
    if (oz >= jug) {
      if (oz > jug * 10) {
        return `
        ${status} or ${Math.floor((oz + jug / 2) / jug)} 
        (${jug} fl oz) jugs
      `;
      } else {
        return `
        ${status} or ${Math.floor((oz / jug) * 10 + 0.5) / 10} 
        (${jug} fl oz) jugs
      `;
      }
    }
    return status;
  },
  printCSI(value) {
    if (value <= -0.6) return "Corrosion of plaster likely";
    else if (value <= -0.3) return "Potential to become corrosive to plaster";
    else if (value < 0.3) return "Balanced";
    else if (value < 0.6) return "Potential to become scaling";
    else if (value >= 0.6) return "Scaling likely";
    return "Invald Inputs";
  },
};
